<template>
	<span v-html="field.specific_data"></span>
</template>

<script>

export default {

	props: [ 'row', 'field' ],

	mounted() {
		this.rules = {};
	}
};
</script>
